import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ShareddtaService } from './shareddta.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private socket: WebSocket | undefined;
  port = environment.port;

  private connectionStatus: boolean = false;
  private messageHandler: ((event: MessageEvent) => void) | undefined;

  private manuallyDisconnected: boolean = false;

  constructor(public ShareddtaServices: ShareddtaService) {
    this.setupOnlineOfflineListeners();
  }

  // Manually trigger a WebSocket connection
  public connect() {

    if (this.connectionStatus) {
      console.log('WebSocket already connected.');
      return;
    }

    this.manuallyDisconnected = false;
    this.connection();
  }

  // Manually disconnect the WebSocket
  public disconnect() {

    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('Manually disconnecting WebSocket...');
      this.manuallyDisconnected = true;
      this.socket.close();
    }
  }

  private connection() {

    // Agar pehle se open ho to dubara mat connect karo
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return;
    }

    let additionalParam = localStorage.getItem('schema_name');
    let additionalParam1 = localStorage.getItem('org_domain');

    if (!additionalParam1) {
      console.error('org_domain is null');
      return;
    }

    const url = new URL(additionalParam1);
    const hostname = url.hostname;

    this.socket = new WebSocket(
      `wss://${hostname}:${this.port}/ws/update-order-status/${additionalParam}/`
    );

    this.socket.onopen = () => {
      this.connectionStatus = true;
      this.manuallyDisconnected = false;

      console.log('WebSocket Connection established');

      // Reassign stored message handler if available
      if (this.messageHandler) {
        this.socket!.onmessage = this.messageHandler;
      }
    };

    this.socket.onclose = () => {
      this.connectionStatus = false;
      console.log('WebSocket Connection closed');

      if (!this.manuallyDisconnected) {
        this.reconnect();
      }
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket Error:', error);
    };

    const messageHandler = (event: MessageEvent) => {
      this.handleReceivedData(event.data);
    };

    this.messageHandler = messageHandler;

    this.socket.onmessage = messageHandler;
  }

  private handleReceivedData(data: any): void {
    console.log('Handling received data:', data);
    this.ShareddtaServices.updateData(data);
  }

  private setupOnlineOfflineListeners() {

    window.addEventListener('online', () => {
      console.log('Browser Online');

      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
        if (!this.manuallyDisconnected) {
          console.log('Reconnecting WebSocket due to online status...');
          this.connection();
        }
      }
    });

    window.addEventListener('offline', () => {
      console.log('Browser Offline');

      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        console.log('Closing WebSocket due to offline status...');
        this.socket.close();
      }
    });
  }

  private reconnect() {

    setTimeout(() => {

      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {

        if (!this.manuallyDisconnected) {
          console.log('Attempting to reconnect WebSocket...');
          this.connection();
        }

      }

    }, 3000);
  }

  public receiveData(callback: (data: any) => void): void {
    if (!this.socket) {
      console.error('WebSocket connection is not established.');
      return;
    }
  }
}
